import * as chrono from "chrono-node";
import { sortByProp } from "./sortByProp";
import { formatKnownImplied } from "./formatKnownImplied";
import { refreshCurrentDate } from "../threads/cpcoc/currentDate";
// https://github.com/wanasit/chrono
export function textToDates(nlEvents, reference) {
    const events = [];
    const today = refreshCurrentDate();
    reference = reference || today;
    for (let i = 0, l = nlEvents.length; i < l; i++) {
        const nlEvent = nlEvents[i];
        const dateObj = {
            text: nlEvent,
            originText: nlEvent.replace(/\s+/g, " ").trim(),
            parsedDateText: [],
            results: chrono.parse(nlEvent, reference),
        };
        dateObj.timeIncluded = dateObj.results.length > 1 ? true : false;
        if (dateObj.results.length) {
            let dateStr = "";
            // build dateStr first
            for (let dri = 0, drl = dateObj.results.length; dri < drl; dri++) {
                const dateArray = dateObj.results[dri];
                dateStr += " " + dateArray.text.trim();
                dateObj.text = dateObj.text
                    .replace(dateArray.text, "")
                    .replace(/\s+/g, " ")
                    .trim();
                dateObj.parsedDateText.push(dateArray.text.replace(/\s+/g, " ").trim());
            }
            dateObj.results.unshift(chrono.parse(dateStr, reference)[0]);
            dateObj.startDate = formatKnownImplied(dateObj.results[0].start);
            dateObj.endDate = formatKnownImplied(dateObj.results[0].end);
            if (dateObj.endDate > today ||
                (dateObj.startDate > today && !dateObj.endDate)) {
                // only display if in the future
                events.push(dateObj);
            }
        }
    }
    return events.sort(sortByProp("startDate"));
}
